export const TypeCompany = {
    company: 0,
    provider: 1,
}